import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  Divider,
  Typography,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

import { baseUrl } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { ClientListHead } from '../../_dashboard/clients';
import { useConstantsContext } from '../../../context/constants_context';
import Controls from '../../controls/Controls';

if (pdfjsLib && pdfjsWorker) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
}

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'provn', label: 'Description', alignRight: false },
  { id: 'department', label: 'No of Claims', alignRight: true },
  { id: 'tarrifCode', label: 'Total Claimed', alignRight: true },
  { id: 'description', label: 'Total Awarded', alignRight: true }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClaimsStatistics() {
  const { payCycles } = useConstantsContext();
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [statsType, setStatsType] = useState('ClaimsByGroup');
  const [begDate, setBegDate] = useState(Number(sessionStorage.getItem('payCycleId')) - 1);
  const [endDate, setEndDate] = useState(Number(sessionStorage.getItem('payCycleId')));
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docType, setDocType] = useState('pdf');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [provider, setProvider] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [iframeSrc, setIframeSrc] = useState('');
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const filename = `ClaimStatistics_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    // getClaimsByProviderSum();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const GetClaimsStats = () => {
    if (statsType === 'ClaimsByDiagnosis') GetClaimsStatsDiag();
    else GetClaimsStatsOther();
  };

  const GetClaimsStatsOther = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/claims/GetClaimsStats?from=${begDate}&to=${endDate}&dateType=1&reportDesc=${statsType}`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('returned Provider GetClaimsStats Summary list', result);
          setDataList(result.result);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in GetClaimsStats!: ${error}`, 'error');
        }
      );
  };

  const GetClaimsStatsDiag = () => {
    setLoading(true);
    fetch(`${baseUrl}/api/claims/GetClaimsStatsDiag?from=${begDate}&to=${endDate}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('returned Provider GetClaimsStatsDiag Summary list', result);
          setDataList(result.result);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in GetClaimsStatsDiag!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/report/getnew/ClaimsStats/${docType}/${statsType}/0/1/${begDate}/${endDate}`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Claims Summary!: ${error}`, 'error');
        }
      );
  };

  const handlePrintPreview = async () => {
    setLoading(true);
    try {
      const url = `${baseUrl}/api/report/getnew/ClaimsStats/${docType}/${statsType}/0/1/${begDate}/${endDate}`;

      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);
      setIframeSrc(fileURL);
      // setOpenPreviewDialog(true);
    } catch (error) {
      console.error('Error fetching print preview:', error);
      notifyPopup(`Error fetching payroll report: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const setSelection = (e) => {
    setStatsType(e);
    if (e === 'ClaimsByGroup') setProvider(1);
    else if (e === 'ClaimsByAge') setProvider(2);
    else if (e === 'ClaimsByType') setProvider(3);
    else setProvider(2);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={5} sm={2}>
          <Typography component="span" variant="h4" gutterBottom>
            Claims Statistics
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel id="selectoc">Stats Type</InputLabel>
            <Select
              labelId="selectChangelabel"
              id="statsType"
              value={statsType}
              size="small"
              variant="standard"
              onChange={(e) => {
                setSelection(e.target.value);
              }}
            >
              <MenuItem value="ClaimsByGroup">Claims By Province</MenuItem>
              <MenuItem value="ClaimsByAge">Claims By Age</MenuItem>
              <MenuItem value="ClaimsByType">Claims By Type</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              size="small"
              value={docType}
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="payCycleLbl">Pay Period</InputLabel>
            <Select
              id="payCycleID"
              value={begDate}
              name="payCycleID"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                setBegDate(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {payCycles.map((item) => (
                <MenuItem key={item.payCycleId} value={item.payCycleId}>
                  {moment(item.payDate).format('YYYY-MM-DD')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="payCycleLbl">Pay Period</InputLabel>
            <Select
              id="payCycleID"
              value={endDate}
              name="payCycleID"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {payCycles.map((item) => (
                <MenuItem key={item.payCycleId} value={item.payCycleId}>
                  {moment(item.payDate).format('YYYY-MM-DD')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => handlePrintPreview()}
          >
            Preview
          </Button>
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Export
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      {iframeSrc ? (
        <Worker>
          <div style={{ height: '100vh', width: '100%' }}>
            <Viewer fileUrl={iframeSrc} plugins={[defaultLayoutPluginInstance]} />
          </div>
        </Worker>
      ) : (
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table size="small" aria-label="a dense table">
                <ClientListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={dataList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      /* eslint-disable camelcase */
                      const { descriptions, noOfClaims, totalClaimed, totalAwarded } = row;
                      const isItemSelected = selected.indexOf(descriptions) !== -1;

                      return (
                        <StyledTableRow
                          hover
                          key={descriptions}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox" />
                          <TableCell align="left">{descriptions}</TableCell>
                          <TableCell align="right">{noOfClaims}</TableCell>
                          <TableCell align="right">{totalClaimed.toFixed(2)}</TableCell>
                          <TableCell align="right">{totalAwarded.toFixed(2)}</TableCell>
                        </StyledTableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isListEmpty && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </Scrollbar>

          <TablePagination
            className={classes.tableFooter}
            rowsPerPageOptions={[8, 16, 24]}
            component="div"
            count={dataList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      )}
    </Container>
  );
}
